<template>
<div id="list-circulaire">

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="dataList">
        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Date</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Titre</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Crée par</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Actions</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :style="{ backgroundColor: color(tr.creeLe) }">

                    <vs-td >
                        <p>{{ tr.creeLe.substring(0,10)}}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.title }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.creePar }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="DownloadIcon" color="primary" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="OpenModal( tr.No)" />
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

</div>
</template>

<script>
import circulaireService from "@/http/requests/circulaire/index.js";

export default {
    data() {
        return {
            imgView: require("@/assets/images/portrait/small/eye.svg"),
            itemsPerPage: 10,
            dataList: [],
            title: "",
        }
    },
    watch: {
        dataList: function (val) {
            if (val.length > 0) {
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
            }
        }
    },
    methods: {
        color(date) {
            if (date.substring(0, 10) > this.getDate())
                return "#FF9F43"
        },
        getDate() {
            var today = new Date(Date.now());
            today.setDate(today.getDate() + (-7));
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();
            today = yyyy + "-" + mm + "-" + dd;
            return today;
        },
        confirmer() {
            this.$vs.loading();
            console.log(this.$refs.fileInput.filesx)
            const circulaireData = {
                file: this.$refs.fileInput.filesx[this.$refs.fileInput.filesx.length - 1],
                title: this.title
            }
            try {
                circulaireService.Add(circulaireData).then(response => {
                    this.$vs.loading.close();
                    this.title = ""
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: "Vous avez importer.",
                        showConfirmButton: true,
                        timer: 2500
                    });
                    this
                    console.log(response)
                }).catch(error => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 10000,
                        title: "Erreur s'est produite l'ors de la validation",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                })
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la validation",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
        loadData() {
            try {
                circulaireService.getAll().then(response => {
                    this.dataList = response.data
                })
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
        successUpload() {
            this.$vs.notify({
                color: 'default',
                title: 'Upload Success',
                text: 'Lorem ipsum dolor sit amet, consectetur'
            })
        }
    },
    computed: {
        DisableConfirmer() {
            return this.title == ""
        }
    },
    created() {
        if (this.$store.state.AppActiveUser.id != '') {
            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {
        this.isMounted = true;
        this.$vs.loading({
            background: this.backgroundLoading,
            // color: this.colorLoading,
            type: 'radius',
            container: "#list-circulaire",
            scale: 0.45,
            clickEffect: true
        });
    }
}
</script>

<style lang="scss">
#list-circulaire {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
